import { render, staticRenderFns } from "./SithMesPrdProjectPlanPrpENManage.vue?vue&type=template&id=1c566ec2&scoped=true&"
import script from "./SithMesPrdProjectPlanPrpENManage.vue?vue&type=script&lang=js&"
export * from "./SithMesPrdProjectPlanPrpENManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c566ec2",
  null
  
)

export default component.exports